import { SxProps, Theme } from "@mui/material";
import { useEffect, useState } from "react";
import { Grid, TextField } from "src/components";
import Autocomplete from "src/components/Autocomplete";
import { CustomGroupPredicate } from "src/models/api.request";
import VwPersonelDTO from "src/models/GenelTanimlar/VwPersonelDTO";
import VwPersonel from "src/models/GenelTanimlar/VwPersonelDTO";
import { useBransGetAllQuery } from "src/services/Settings/Generals/BransTanimApi";
import personelService from "src/services/Settings/Generals/personel.service";
import { useAppSelector } from "src/store";
import ParametreGrupEnum from "src/enums/ParametreGrupEnum";
import { helper } from "src/utils/helper";
import { getParameterValue } from "src/utils/ParametreHelper";
import { AutoCompleteTargetString } from "../Types/autocomplete.target";
import { translate } from "src/i18n/tHelper";

interface IPersonelMultiAutoCompleteProps {
    value?: string;
    name?: string;
    label?: string;
    predicate?: CustomGroupPredicate<VwPersonelDTO>;
    onChange?: (e: AutoCompleteTargetString, value: VwPersonel[]) => void;
    helperText?: string
    sx?: SxProps<Theme>;
    id?: string;
    placeholder?: string;
    error?: boolean;
    readonly?: boolean;
}

const sleep = (delay = 0) => {
    return new Promise((resolve) => {
        setTimeout(resolve, delay);
    });
}
const translatePath = "common";
const PersonelAutoCompleteMulti = (props: IPersonelMultiAutoCompleteProps): JSX.Element => {
    const [options, setOptions] = useState(new Array<VwPersonel>());
    const [value, setValue] = useState<Array<VwPersonel>>(new Array<VwPersonel>())
    const [errorMessage, setErrorMessage] = useState<string>("")
    const [inputValue, setInputValue] = useState("");
    const [loading, setLoading] = useState(false);
    const { organizasyon } = useAppSelector(state => state.userOrganizasyon);
    const bransState = useBransGetAllQuery();
    useEffect(() => {
        if (props.value) {

            personelService.find({
                filters:
                {
                    groupOperator: "and",
                    predicates: [{
                        fieldName: "id",
                        operator: "in",
                        value1: props.value.split(",")
                    }]
                }
            }).then(res => {
                if (res.responseCode !== 200) {
                    setErrorMessage(res.errorMessage)
                    return;
                }
                setValue(res.data)
            })
        }
        else setValue([])
    }, [props.value])

    useEffect(() => {
        let active = true;
        if (inputValue === '') {
            setOptions(value?.length > 0 ? value : []);
            return undefined;
        }
        (async () => {
            setLoading(true)
            await sleep(1e3);

            if (active) {
                var predicate = new CustomGroupPredicate<VwPersonelDTO>();
                predicate.groupOperator = "and";
                predicate.predicates.push({
                    fieldName: "treekey",
                    operator: "startsWith",
                    value1: organizasyon.treekey,
                },
                    {
                        fieldName: "searchText",
                        operator: "like",
                        value1: helper.UpperCaseAsc(inputValue)
                    },
                )
                if (props.predicate)
                    predicate.predicates.push(props.predicate);

                const res = await personelService.find({
                    filters: predicate,
                    sorts: [
                        { fieldName: "adi" },
                        { fieldName: "soyadi" }
                    ]
                })
                if (res.responseCode !== 200) {
                    setErrorMessage(res.errorMessage)
                    return;
                }
                setOptions(res.data);
                setLoading(false)
            }
        })();

        return () => {
            active = false;
        };
    }, [inputValue]);

    useEffect(() => {
        setErrorMessage(props.helperText)
    }, [props.helperText])

    return (
        <Autocomplete
            fullWidth
            sx={props.sx}
            id={props.id}
            readOnly={props.readonly}
            multiple
            freeSolo={false}
            value={value ? value : []}
            options={options}
            loading={loading}
            loadingText={translate(translatePath, "Yükleniyor")}
            getOptionLabel={(option) => {
                if (!option.adi)
                    return "";
                return option.adi + " " + option.soyadi + " - " + bransState.data?.find(f => f.id === option.bransId)?.adi;
            }
            }
            filterOptions={(x) => x}
            autoComplete
            includeInputInList
            filterSelectedOptions
            onChange={(event: any, newValue) => {
                setOptions(newValue ? newValue : options);
                setValue(newValue);
                if (props.onChange) {
                    var val = "";
                    if (newValue) {
                        for (var i in newValue) {
                            if (val)
                                val += ",";
                            val += newValue[i].id;
                        }
                    }
                    props.onChange({ target: { value: val, name: props.name } }, newValue);
                }

            }}
            onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder={props.placeholder}
                    label={props.label}
                    error={props.error || Boolean(errorMessage)}
                    helperText={errorMessage}
                />
            )}
            renderOption={(p, v, s) => {
                if (!v?.id)
                    return "";
                const bransAdi = bransState.data?.find(f => f.id === v.bransId)?.adi;
                return (
                    <li {...p} key={v.id}>
                        <Grid container>
                            <Grid item md={12}>
                                {v.adi + " " + v.soyadi + (v.kimlikNo ? " - " + v.kimlikNo : "")}
                            </Grid>
                            <Grid item md={12}>
                                {getParameterValue(ParametreGrupEnum.PersonelTurleri, v.grupId) + (bransAdi ? " - " + bransAdi : "")}
                            </Grid>
                        </Grid>
                    </li>
                )
            }
            }
        />
    )

}
export default PersonelAutoCompleteMulti;